import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import Crew from './components/Crew';
import Projects from './components/Projects';
import Products from './components/Products';
import Contact from './components/Contact';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import NotFound from './components/NotFound';
import Shawn from './components/shawn';
import Kaeden from './components/Kaeden';
import Alec from './components/Alec';
import CommunityImpact from './components/CommunityImpact';
import LiveApps from './components/LiveApps';
import Funnel from './components/Funnel';
import CookieConsent from './components/CookieConsent';
import { initScrollReveal, scanRevealTargets } from './utils/scrollReveal';
import './App.css';
import './scroll-reveal.css';

function ScrollRevealRouter() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on route change so reveal animations play from the top.
    window.scrollTo({ top: 0, behavior: 'auto' });
    // Initial scan on mount, then re-scan after a tick so newly mounted
    // page elements get observed.
    initScrollReveal();
    const t = setTimeout(() => scanRevealTargets(), 80);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        {/* Read position, driven by --scroll-progress on :root. */}
        <div className="scroll-progress" aria-hidden="true" />
        <a className="skip-link" href="#main">Skip to content</a>
        <Navbar />
        <ScrollRevealRouter />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/crew" element={<Crew />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/crew/shawn" element={<Shawn />} />
          <Route path="/crew/kaeden" element={<Kaeden />} />
          <Route path="/crew/alec" element={<Alec />} />
          <Route path="/community-impact" element={<CommunityImpact />} />
          <Route path="/live-apps" element={<LiveApps />} />
          <Route path="/start" element={<Funnel />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
